/* eslint-disable @wyz/module/no-relative-import */
import { Flex, Icon, Navbar } from '@wyz/ui';
import clsx from 'clsx';
import { useRef } from 'react';
import { PlatformLogo, TopNavbarPortal } from '~/common/components';
import { useConfig, useTheme } from '~/common/context';
import TopNavRightSideNavItem from './top-nav-right-side-nav-item';
const NavbarTop = () => {
  const { navbarPosition, isNavbarVerticalCollapsed, setConfig } = useTheme();
  const burgerMenuRef = useRef(null);
  const theme = useTheme();
  const { environment } = useConfig();

  const handleBurgerMenu = () => {
    const newState = !isNavbarVerticalCollapsed;
    setConfig('isNavbarVerticalCollapsed', newState);
    setConfig('showBurgerMenu', !newState);
  };

  return (
    <>
      <Navbar.Toggle
        ref={burgerMenuRef}
        className={clsx('toggle-icon-wrapper me-md-3 me-2', {
          [`d-${String(theme.navbarBreakPoint)}-none`]:
            navbarPosition === 'vertical',
        })}
        as='div'
      >
        <button
          className='navbar-toggler-humburger-icon btn btn-link d-flex flex-center'
          onClick={handleBurgerMenu}
          id='burgerMenu'
        >
          <Icon
            icon={theme.isNavbarVerticalCollapsed ? 'opened-burger' : 'close'}
          />
        </button>
      </Navbar.Toggle>
      <Flex alignItems='center'>
        <PlatformLogo id='topLogo' />
      </Flex>
      {environment !== 'prod' && environment && (
        <span className={'env-pill'}>{environment}</span>
      )}
      <TopNavbarPortal />

      <TopNavRightSideNavItem />
    </>
  );
};

export default NavbarTop;
